import { Box, Typography, useTheme } from "@material-ui/core";
import { Variant as ThemeVariant } from "@material-ui/core/styles/createTypography";
import { colors as swyftColors } from "swyft-react-core";
import { getKeyValue, StringUnion } from "../../app/utils";
import { PriceFormat } from "./PriceFormat";
import { formatTimestamp } from "swyft-react-core";

export const TF = ({
  bold,
  underline,
  fontAccent,
  fontWeight,
  variant,
  component,
  color,
  fontSize,
  upperCase,
  format,
  children,
  m,
  mt,
  mb,
  mr,
  ml,
  mx,
  my,
  ...rest
}: Props) => {
  const theme = useTheme();
  const boldText = bold ? "fontWeightBold" : "";
  const colorTypography = ColorTypography.check(color);
  const colorSwyft = ColorSwyft.check(color);
  const colorStore = ColorStore.check(color);
  const colorString = color?.startsWith("#") ? color : undefined;

  const style = {} as Style;

  const convertSpacing = (value: any) => {
    const num = Number(value);

    return isNaN(num) ? value : theme.spacing(value);
  };

  if (upperCase) {
    style.textTransform = "uppercase";
  }

  if (colorString) {
    style.color = colorString;
  }

  if (colorSwyft) {
    style.color = getKeyValue(swyftColors, colorSwyft);
  }

  if (colorStore) {
    style.color = getKeyValue(colors, colorStore);
  }

  if (m) {
    style.margin = convertSpacing(m);
  }

  if (mr) {
    style.marginRight = convertSpacing(mr);
  }

  if (ml) {
    style.marginLeft = convertSpacing(ml);
  }

  if (mt) {
    style.marginTop = convertSpacing(mt);
  }

  if (mb) {
    style.marginBottom = convertSpacing(mb);
  }

  if (mx) {
    style.marginLeft = convertSpacing(mx);
    style.marginRight = convertSpacing(mx);
  }

  if (my) {
    style.marginTop = convertSpacing(my);
    style.marginBottom = convertSpacing(my);
  }

  if (underline) {
    style.textDecoration = "underline";
  }

  if (fontAccent) {
    style.fontFamily = "Axiforma, serif, sans-serif ";
  }

  style.fontSize = fontSize;

  let childrenSection = <>{children}</>;

  if (format === "price") {
    childrenSection = <PriceFormat value={children as number} />;
  }

  if (format === "timestamp") {
    childrenSection = <>{formatTimestamp(children as number)}</>;
  }

  if (!variant) {
    //todo revert to use body1
    variant = "body2";
  }

  return (
    <>
      <Typography {...rest} style={style} variant={variant} component={component} color={colorTypography}>
        <Box fontWeight={boldText || fontWeight} component="span">
          {childrenSection}
        </Box>
      </Typography>
    </>
  );
};

type spacing = SimpleStyleFunction<
  | "m"
  | "mt"
  | "mr"
  | "mb"
  | "ml"
  | "mx"
  | "my"
  | "p"
  | "pt"
  | "pr"
  | "pb"
  | "pl"
  | "px"
  | "py"
  | "margin"
  | "marginTop"
  | "marginRight"
  | "marginBottom"
  | "marginLeft"
  | "marginX"
  | "marginY"
  | "padding"
  | "paddingTop"
  | "paddingRight"
  | "paddingBottom"
  | "paddingLeft"
  | "paddingX"
  | "paddingY"
>;
export type SpacingProps = PropsFor<spacing>;

export type PropsFor<SomeStyleFunction> = SomeStyleFunction extends StyleFunction<infer Props> ? Props : never;
export type StyleFunction<Props> = (props: Props) => any;
type SimpleStyleFunction<PropKey extends keyof any> = StyleFunction<Partial<Record<PropKey, any>>>;

export const colors = {
  storeGrey: "#979797",
  storeRed: "#FF0A0A"
};

type Variant = ThemeVariant | "srOnly";
type ColorString = string;
const ColorTypography = StringUnion(
  "initial",
  "inherit",
  "primary",
  "secondary",
  "textPrimary",
  "textSecondary",
  "error"
);
type ColorTypographyType = typeof ColorTypography.type;

const ColorSwyft = StringUnion(
  "white",
  "black",
  "grey",
  "darkGrey",
  "lightGrey",
  "lighterGrey",
  "lightPrimary",
  "lightSecondary",
  "lighterSecondary",
  "alternate"
);
type ColorSwyftType = typeof ColorSwyft.type;

const ColorStore = StringUnion("storeGrey", "storeRed");
type ColorStoreType = typeof ColorStore.type;

type Color = ColorTypographyType | ColorString | ColorSwyftType | ColorStoreType;
type Format = "price" | "timestamp";

interface Props extends SpacingProps {
  bold?: boolean;
  upperCase?: boolean;
  component?: any;
  variant?: Variant;
  children?: React.ReactNode;
  color?: Color;
  fontSize?: string;
  fontWeight?: string | number;
  format?: Format;
  underline?: boolean;
  fontAccent?: boolean;
  [x: string]: any;
}

interface Style {
  color?: string;
  fontSize?: string;
  margin?: string;
  marginLeft?: string;
  marginRight?: string;
  marginTop?: string;
  marginBottom?: string;
  textTransform?: any;
  textDecoration?: string;
  fontFamily?: string;
}
